import { Pipe, PipeTransform } from '@angular/core';
import { hasAny } from '../util';

@Pipe({
    name: 'any',
    standalone: true,
})
export class AnyPipe implements PipeTransform {
    transform(value: ArrayLike<any> | null | undefined): boolean {
        return hasAny(value);
    }
}
